<template>
  <div v-if="id_pagamento_atendimento && ( !view_only || transaction_id )">
    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown"
      title="Integração Zoop" id="integracao-zoop-status-button" aria-haspopup="true" aria-expanded="false">
      Zoop
    </button>

    <div class="dropdown-menu" aria-labelledby="integracao-zoop-status-button">
        <a class="dropdown-item disabled" v-if="transaction_id">
            <i class="fa-solid fa-split fa-fw mr-2" v-if="split_realizado"></i>
            Zoop: {{ transaction_id }}
        </a>
        <template v-if="!view_only">
            <a class="dropdown-item" href="#" @click="enviarPagamentoPixPinpad()"> Pagar via PIX (PIN PAD) </a>
            <a class="dropdown-item" href="#" @click="enviarPagamentoCartaoPinpad()"> Pagar com cartão (PIN PAD) </a>
        </template>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#" @click="logComunicacao()">
            <i class="fa-solid fa-book fa-fw mr-2"></i>
            Log de Comunicação
        </a>
    </div>

    <log-integracao ref="logInt" />

    <pre v-if="1 == 0">{{ atendimento }}</pre>

    <div class="custom-backdrop" v-if="mostrarModalCartao"></div>

    <div class="modal" id="cartaoModal" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel"
      aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">Dados do cartão</h5>
            <button type="button" class="close" @click="fecharModalCartao()">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <dados-cartao-component @update-cartao="receberCartao"></dados-cartao-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import LogIntegracao from "../shared/audit/LogIntegracao.vue";
import DadosCartaoComponent from "./DadosCartaoComponent.vue";
import Vue from "vue";

export default {
  data() {
    return {
      dadosCartao: false,
      cartao: {
        numeroCartao: "",
        nomeTitular: "",
        dataValidade: "",
        cvv: "",
        tipoCartao: "",
        parcelas: 1,
      },
      mostrarModalCartao: false,
      token: null,
      marketplace_id: null,
      authorization: null,
    };
  },

  props: {
    id_pagamento_atendimento: {
      type: Number,
      required: true,
    },
    pagamento_atendimento: { 
      type: Object,
      required: false,
    },
    view_only: { 
      type: Boolean,
      required: false,
    },
  },

  computed: { 
    transaction_id: function() {
        if ( !this.pagamento_atendimento )
            return; 
        
        let transaction_id = _.get(this.pagamento_atendimento, 'zoop.transaction_id', null);
        
        if ( !transaction_id ) { 
             transaction_id = _.uniq(
                this.pagamento_atendimento.item_pagamento_atendimentos.map(ipa => _.get(ipa, 'js_outros.zoop.transaction_id', null))
                    .filter(item => item)
            ).join(", ");
        }

        return transaction_id;
    },

    split_realizado: function() {
        return _.get(this.pagamento_atendimento, 'js_outros.zoop.ajuste_pos_split', null) ? true : false;
    },
  },

  components: {
    LogIntegracao,
    DadosCartaoComponent,
  },

  methods: {
    enviarPagamentoPix: function () {
      this.$util.atualizar(this, {
        service: "atendimentos",
        func: "zoop_pagamento_pix",
        redir_api: true, 
        dados: {
          id_pagamento_atendimento: this.id_pagamento_atendimento,
        },
        callback: (res) => {
          if (res) {
            this.$toast.add({
              severity: res.status == "success" ? "success" : "error",
              summary: res.status == "success" ? "Sucesso" : "Erro",
              detail: res.msg || (res.ok == "success" ? "Pagamento realizado com sucesso." : "Erro ao realizar o pagamento."),
              life: 3000,
            });
          }
        },
      });
    },

    enviarPagamentoPixPinpad: function () {
      this.$util.atualizar(this, {
        service: "atendimentos",
        func: "zoop_pagamento_pix_pinpad",
        redir_api: true, 
        dados: {
          id_pagamento_atendimento: this.id_pagamento_atendimento,
        },
        callback: (res) => {
          if (res) {
            this.$toast.add({
              severity: res.status == "success" ? "success" : "error",
              summary: res.status == "success" ? "Sucesso" : "Erro",
              detail: res.msg || (res.ok == "success" ? "Pagamento realizado com sucesso." : "Erro ao realizar o pagamento."),
              life: 3000,
            });
          }
        },
      });
    },

    logComunicacao: function () {
      this.$refs.logInt.abrir("pagamentoAtendimento", this.id_pagamento_atendimento, true);
    },

    abrirModalCartao() {
      this.mostrarModalCartao = true;
      $("#cartaoModal").show();
    },

    fecharModalCartao() {
      this.mostrarModalCartao = false;
      $("#cartaoModal").hide();
    },

    receberCartao(dados) {
      this.cartao = dados;
      this.enviarPagamentoCartao();
    },

    async enviarPagamentoCartao() {
      await this.$util.atualizar(this, {
        service: "atendimentos",
        func: "zoop_pegar_dados_clinica",
        redir_api: true, 
        callback: async (res) => {
          if (res) {

            const marketplace_id = (this.marketplace_id = res.marketplace_id);
            const authorization = (this.authorization = res.authorization);
            const [mes, ano] = this.cartao.dataValidade.split("/");
            const header = {
              "accept": "application/json",
              "content-type": "application/json",
              "Authorization": authorization,
            };

            const expiration_month = mes;
            const expiration_year = "20" + ano;
            const axiosZoop = await Vue.axios.create();

            const responseToken = await axiosZoop.post(
              `https://api.zoop.ws/v1/marketplaces/${marketplace_id}/cards/tokens`,
              {
                holder_name: this.cartao.nomeTitular,
                expiration_month: expiration_month,
                expiration_year: expiration_year,
                card_number: this.cartao.numeroCartao,
                security_code: this.cartao.cvv
              },
              {
                headers: header,
              }
            );

            if (responseToken && responseToken.data && responseToken.data.id) {
              this.token = responseToken.data.id;

              this.$util.atualizar(this, {
                service: "atendimentos",
                func: "zoop_pagamento_cartao",
                redir_api: true, 
                dados: {
                  id_pagamento_atendimento: this.atendimento.id_atendimento,
                  token: this.token,
                  parcelas: this.cartao.parcelas,
                  tipoCartao: this.cartao.tipoCartao,
                  bandeira: this.cartao.bandeira,
                },
                callback: (res) => {
                  if (res) {
                    this.$toast.add({
                      severity: res.status == "success" ? "success" : "error",
                      summary: res.status == "success" ? "Sucesso" : "Erro",
                      detail: res.msg || (res.ok == "success" ? "Pagamento realizado com sucesso." : "Erro ao realizar o pagamento."),
                      life: 3000,
                    });
                  }
                },
              });
            }

          } else {
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: res.msg || "Erro ao realizar o pagamento.",
              life: 3000,
            });
          }
        },
      });
    },

    async enviarPagamentoCartaoPinpad() {
      await this.$util.atualizar(this, {
        service: "atendimentos",
        func: "zoop_pagamento_cartao_pinpad",
        redir_api: true, 
        dados: {
          id_pagamento_atendimento: this.id_pagamento_atendimento
        },
        callback: (res) => {
          if (res) {
            this.$toast.add({
              severity: res.status == "success" ? "success" : "error",
              summary: res.status == "success" ? "Sucesso" : "Erro",
              detail: res.msg || (res.ok == "success" ? "Pagamento realizado com sucesso." : "Erro ao realizar o pagamento."),
              life: 3000,
            });
          }
        },
      });
    },
  },

  mounted() { },
};
</script>
<style>
#cartaoModal {
  z-index: 99999;
}

.custom-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}
</style>
